export default __webpack_public_path__ + "static/lifeprint-2-14cba339647f0427b9e671bb52879230.webp";